exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".captcha-group{padding:15px;background-color:#1b1b1b;margin-bottom:30px}.captcha-group .message{text-align:center}.g-recaptcha div{margin:1.5rem auto 0}.submit-box{width:50%;float:right;clear:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/submit/submit.styl
// module id = 289
// module chunks = 0 1